import gql from 'graphql-tag';

const GET_CLIENT_VIEWS = gql`
  query {
    getClientViews {
      id
      name
      shared
      viewCondition
      customView
      systemViewProperty
    }
  }
`;

const GET_QUOTE_VIEWS = gql`
  query {
    getQuoteViews {
      id
      name
      shared
      viewCondition
      customView
      systemViewProperty
    }
  }
`;

const GET_QUOTE_LIST = gql`
  query getQuoteList($listInfo: ListInfoInput) {
    getQuoteList(listInfo: $listInfo) {
      quotes {
        quoteId
        displayId
        quoteDate
        expiryDate
        statusEnum
        totalAmount
        client {
          accountId
          name
        }
        invoice {
          invoiceId
        }
        title
        description
      }
      listInfo {
        hasMore
        pageSize
        page
        condition
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_MAILBOX_VIEWS = gql`
  query {
    getSalesInboxViews {
      id
      name
      shared
      viewCondition
      customView
      systemViewProperty
    }
  }
`;

const GET_CLIENT_LISTVIEW_META = gql`
  query {
    getClientListViewMetaInfo
  }
`;

const GET_CLIENT_SLA = gql`
  query getClientSLAs($clientId: ID!) {
    getClientSLAs(clientId: $clientId) {
      id
      sla {
        id
        name
      }
      client {
        name
        accountId
      }
      slaOrder
    }
  }
`;

const GET_INVOICE_SETTINGS = gql`
  query getInvoiceSettings($clientId: ID!) {
    getInvoiceSettings(clientId: $clientId) {
      invoiceType
      scheduleDate
      frequency
      paymentDueDays
      sendEmail
      ticketStatus
      enabled
    }
  }
`;

const GET_CLIENT_INVOICE_SETTINGS = gql`
  query getInvoiceSetting($clientId: ID!) {
    getInvoiceSetting(clientId: $clientId) {
      invoiceSchedule
      invoiceDueDays
      ticketLineItemContent
      ticketLineItemPlaceholdersUsed
      projectLineItemContent
      projectLineItemPlaceholdersUsed
      autoPushInvoice
      generateSiteSpecific
      taxExempted
      scheduleEnabled
      salesTax {
        taxId
        name
        rates {
          rateId
          name
          rateValue
        }
      }
      sendTemplate {
        id
        name
        subject
        content
        placeholdersUsed
        to {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            firstName
            lastName
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        cc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }
        bcc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }
        activated
        templateSubtype
        attachmentList {
          fileName
          originalFileName
          fileSize
        }
      }
    }
  }
`;

const GET_CLIENT_INVOICE_SETTING = gql`
  query getInvoiceSettings($input: ClientIdentifierInput) {
    getInvoiceSettings(input: $input) {
      settingId
      invoiceSchedule
      invoiceDueDays
      ticketLineItemContent
      ticketLineItemPlaceholdersUsed
      projectLineItemContent
      projectLineItemPlaceholdersUsed
      autoPushInvoice
      generateSiteSpecific
      taxExempted
      scheduleEnabled
      invoiceTemplate {
        templateId
        memo
        title
        footer
        layoutConfiguration
        preferences
      }
      quoteTemplate {
        templateId
        memo
        title
        footer
        layoutConfiguration
        preferences
      }
      salesTax {
        taxId
        name
        rates {
          rateId
          name
          rateValue
        }
      }
      sendTemplate {
        id
        name
        subject
        content
        placeholdersUsed
        to {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            firstName
            lastName
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        cc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }
        bcc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }

        activated
        templateSubtype
        attachmentList {
          fileName
          originalFileName
          fileSize
        }
      }
    }
  }
`;

const GET_CLIENT_INVOICE_SETTING_NEW = gql`
  query getInvoiceSettings($input: ClientIdentifierInput) {
    getInvoiceSettings(input: $input) {
      settingId
      invoiceSchedule
      invoiceDueDays
      ticketLineItemContent
      ticketLineItemPlaceholdersUsed
      projectLineItemContent
      projectLineItemPlaceholdersUsed
      autoPushInvoice
      generateSiteSpecific
      taxExempted
      scheduleEnabled
      invoiceTemplate {
        templateId
        memo
        title
        footer
        layoutConfiguration
      }
      salesTax {
        taxId
        name
        rates {
          rateId
          name
          rateValue
        }
      }
      sendTemplate {
        id
        name
        subject
        content
        placeholdersUsed
        to {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            firstName
            lastName
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        cc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }
        bcc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }

        activated
        templateSubtype
        attachmentList {
          fileName
          originalFileName
          fileSize
        }
      }
      quoteTemplate {
        templateId
        memo
        title
        footer
        layoutConfiguration
      }
    }
  }
`;

const GET_INVOICE_ADDRESS = gql`
  query getInvoiceAddress($input: GetBillingAddressInput) {
    getInvoiceAddress(input: $input) {
      sender
      billing
    }
  }
`;

const GET_INVOICE_TEMPLATE = gql`
  query getInvoiceTemplate($input: InvoiceTemplateIdentifierInput) {
    getInvoiceTemplate(input: $input) {
      templateId
      title
      memo
      footer
    }
  }
`;

const GET_QUOTE_TEMPLATE = gql`
  query getQuoteTemplate($input: QuoteTemplateIdentifierInput!) {
    getQuoteTemplate(input: $input) {
      templateId
      title
      memo
      footer
    }
  }
`;

const GET_CLIENT_WITH_CUSTOM_FIELDS = gql`
  query getClient($clientId: ID!, $fields: [String!]) {
    getClient(clientId: $clientId) {
      accountId
      customFields(fields: $fields)
    }
  }
`;

const GET_CLIENT = gql`
  query getClient($clientId: ID!) {
    getClient(clientId: $clientId) {
      accountId
      name
      policyMigrationStatus
      integrationStatus {
        xero
        quickBooks
        stripe
        pax8
      }
      primaryContact {
        name
        firstName
        lastName
        email
        phoneNumber
        contactNumber
        countryCode
        userId
      }
      secondaryContact {
        userId
        name
        firstName
        lastName
        email
        phoneNumber
        contactNumber
        countryCode
      }
      accountManager {
        userId
        name
        firstName
        lastName
        email
      }
      technicianGroups {
        name
        groupId
      }
      stage
      status
      accountType
      logoFileName
      emailDomains
      customFields
      hqSite {
        id
        name
      }
    }
  }
`;

const GET_CLIENT_USER_LIST = gql`
  query getClientUserAssociationsList($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
      associations {
        user {
          userId
          firstName
          lastName
          email
          phoneNumber
          contactNumber
          activated
          countryCode
          name
          businessFunction {
            name
            businessFunctionId
          }
          reportingManager {
            userId
            firstName
            lastName
            email
          }
          site {
            id
            name
          }
          customFields
        }
      }
    }
  }
`;

const GET_CLIENT_USERS_LIST = gql`
  query getClientUserAssociationsList($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      associations {
        user {
          userId
          firstName
          lastName
          email
          phoneNumber
          contactNumber
          activated
          countryCode
          name
          reportingManager {
            userId
            firstName
            lastName
            email
          }
          site {
            id
            name
          }
          account {
            accountType
            name
            accountId
          }
          customFields
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;
const GET_USERS_ASSOCIATIONS_LIST = gql`
  query getClientUserAssociationsList($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      associations {
        user {
          userId
          firstName
          lastName
          email
          name
          businessFunction {
            name
            businessFunctionId
          }
          contactNumber
          site {
            id
            name
          }
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CLIENT_USER_ASSOCIATIONS_LIST = gql`
  query getClientUserAssociationsList($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      associations {
        id
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        org {
          accountId
          clientOrg
          companyOrg
          name
        }
        primarySite
        user {
          userId
          firstName
          lastName
          email
          phoneNumber
          contactNumber
          activated
          activationMailStatus
          activationMailFailureReason
          countryCode
          name
          role {
            roleId
            name
          }
          reportingManager {
            userId
            name
            firstName
            lastName
            email
          }
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CLIENT_USER_LISTVIEW_META = gql`
  query {
    getClientUserListViewMetaInfo
  }
`;

const GET_CLIENT_USER_COUNT = gql`
  query getClientUserAssociationsList($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      associations {
        user {
          userId
        }
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
      }
    }
  }
`;

const GET_SUBSCRIPTION_ITEM_QUANTITY_COUNT = gql`
  query getSubscriptionItemQuantity($input: GetSubscriptionItemQuantityInput) {
    getSubscriptionItemQuantity(input: $input)
  }
`;

const GET_CLIENT_CONVERSATIONS = gql`
  query getClientConversationList(
    $listInfo: ListInfoInput
    $isConversation: Boolean!
  ) {
    getClientConversationList(listInfo: $listInfo) {
      conversations {
        client {
          name
          accountId
        }
        minifiedContent
        conversationId
        viewedByClient
        subject
        content
        time
        opened
        user {
          name
          firstName
          lastName
          userId
          email
          accountType
          account {
            accountType
            accountId
          }
        }
        attachments @include(if: $isConversation) {
          fileName
          originalFileName
          fileSize
        }
        toUsers @include(if: $isConversation) {
          user {
            name
            firstName
            lastName
            userId
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        ccUsers @include(if: $isConversation) {
          user {
            name
            firstName
            lastName
            userId
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        bccUsers @include(if: $isConversation) {
          user {
            name
            firstName
            lastName
            userId
            email
          }
          mailDeliveryStatus
          mailFailureReason
        }
        parentConversationId
        latestReply {
          conversationId
          content
          time
          toUsers @include(if: $isConversation) {
            user {
              name
              firstName
              lastName
              userId
              account {
                accountType
                accountId
              }
            }
          }
          attachments @include(if: $isConversation) {
            fileName
            originalFileName
            fileSize
          }
          user {
            name
            firstName
            lastName
            userId
            email
            accountType
            account {
              accountType
              accountId
            }
          }
        }
      }
      listInfo {
        hasMore
        pageSize
        page
        condition
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_CLIENT_ATTACHMENTS = gql`
  query getClientAttachments($clientId: ID!, $listInfo: ListInfoInput) {
    getClientAttachments(clientId: $clientId, listInfo: $listInfo) {
      attachments {
        attachmentId
        fileName
        originalFileName
        fileSize
        attachedBy {
          name
          userId
          email
        }
        attachedOn
      }
      listInfo {
        hasMore
      }
    }
  }
`;

const GET_CLIENT_OFFERINGS = gql`
  query($listInfo: ListInfoInput) {
    getClientOfferings(listInfo: $listInfo) {
      offerings {
        offeringId
        name
        comments
        type
        price
        constant
      }
      listInfo {
        hasMore
      }
    }
  }
`;

const GET_WHITELISTED_OFFERINGS = gql`
  query($clientId: ID!, $listInfo: ListInfoInput) {
    getWhiteListedClientOfferings(listInfo: $listInfo, clientId: $clientId) {
      offerings {
        offeringId
        name
        comments
        type
        price
        constant
      }
      listInfo {
        hasMore
      }
    }
  }
`;

const GET_CLIENT_CONTRACTS = gql`
  query($listInfo: ListInfoInput, $clientId: ID!) {
    getClientContracts(clientId: $clientId, listInfo: $listInfo) {
      contracts {
        contractId
        startDate
        endDate
        pricingType
        price
        blockHoursType
        blockHours
        hasExpiredItems
        overriddenOfferings {
          offering {
            offeringId
            name
            type
          }
          price
        }
        blockedOfferings {
          offeringId
          name
        }
        subscriptions {
          offering {
            offeringId
            name
          }
          quantity
        }
        active
        createdTime
      }
      listInfo {
        hasMore
      }
    }
  }
`;

const GET_CLIENT_EXPIRED_CONTRACTS = gql`
  query($contractId: ID!) {
    getContractExpiredSubscriptions(contractId: $contractId) {
      itemId
      serviceItem {
        name
        quantityType
      }
      unitType
      # subscriptionType
      unitPrice
      quantity
      effectiveDate
      endDate
      autoRenew
      carryForwardRemainingBlockHours
      adjustBlockItemAgainstAllItems
      blockItemUsedIn
      blockItemBalance
      canEdit
      canEditEndDate
      blockHoursUsedIn
      useAsWorklogItem
      amount
    }
  }
`;

const GET_CLIENT_INVOICES = gql`
  query($listInfo: ListInfoInput, $clientId: ID!) {
    getInvoices(clientId: $clientId, listInfo: $listInfo) {
      invoices {
        invoiceId
        displayId
        invoiceType
        status
        totalAmount
        invoiceDate
        dueDate
        items {
          itemId
          itemName
          quantity
          unitPrice
          amount
          worklogItem {
            itemId
            worklog {
              ticket {
                displayId
                ticketId
              }
            }
          }
          offering {
            offeringId
          }
        }
        viewedByClient
      }
      listInfo {
        hasMore
      }
    }
  }
`;

const GET_INVOICE_STATUSES = gql`
  query {
    getInvoiceStatuses {
      statusId
      name
      constant
    }
  }
`;

const GET_INVOICE = gql`
  query($clientId: ID, $invoiceId: ID!) {
    getInvoice(clientId: $clientId, invoiceId: $invoiceId) {
      invoiceId
      displayId
      invoiceType
      status
      totalAmount
      invoiceDate
      dueDate
      items {
        itemId
        itemName
        quantity
        unitPrice
        amount
        worklogItem {
          itemId
          worklog {
            ticket {
              displayId
              ticketId
            }
          }
        }
        offering {
          offeringId
        }
      }
      viewedByClient
    }
  }
`;

const GET_INVOICE_SUMMARY = gql`
  query($clientId: ID!) {
    getInvoiceSummary(clientId: $clientId) {
      pendingInvoiceAmount
      totalRevenueAmount
    }
  }
`;

const HARD_DELETE_CONVERSATION = gql`
  mutation($ids: [ID!]!) {
    hardDeleteClientConversations(ids: $ids)
  }
`;

const SOFT_DELETE_CONVERSATION = gql`
  mutation($ids: [ID!]!) {
    softDeleteClientConversations(ids: $ids)
  }
`;

const RESTORE_CONVERSATION = gql`
  mutation($ids: [ID!]!) {
    restoreDeleteClientConversations(ids: $ids)
  }
`;

const VALIDATE_EMAIL_ADDRESS = gql`
  mutation($email: String!, $accountType: AccountType!, $clientId: ID) {
    validateEmailAddress(
      email: $email
      accountType: $accountType
      clientId: $clientId
    )
  }
`;

const GET_SALES_INBOX_VIEWS_COUNT = gql`
  query getSalesInboxViewsRecordCount(
    $countInput: GetSalesInboxViewsCountInput!
  ) {
    getSalesInboxViewsRecordCount(input: $countInput) {
      viewId
      count
    }
  }
`;

const GET_CONDITIONS_META_FOR_OFFERED_ITEM = gql`
  query {
    getOfferedItemListViewMeta
  }
`;

const GET_CONDITIONS_META_FOR_WORKLOG_ITEM = gql`
  query {
    getWorklogEntriesListViewMeta
  }
`;

const GET_CLIENT_ORIGINAL_MESSAGE = gql`
  query getClientConversationThreadedContent(
    $input: GetConversationThreadedContentInput!
  ) {
    getClientConversationThreadedContent(input: $input)
  }
`;

const GET_CLIENT_INVOICE_SCHEDULE = gql`
  query getInvoiceSettings($input: ClientIdentifierInput) {
    getInvoiceSettings(input: $input) {
      lastScheduleAt
      nextScheduleAt
    }
  }
`;

const GET_CLIENT_INVOICE_SETTINGS_NEW = gql`
  query getInvoiceSettings($input: ClientIdentifierInput) {
    getInvoiceSettings(input: $input) {
      settingId
      invoiceSchedule
      scheduleEnabled
      invoicePaymentTerm {
        paymentTermId
        paymentTermName
        paymentTermValue
        placeholder
        systemPaymentTerm
      }
      invoicePaymentMethod {
        paymentMethodId
        paymentMethodName
      }
      ticketLineItemContent
      ticketLineItemPlaceholdersUsed
      projectLineItemContent
      projectLineItemPlaceholdersUsed
      subscriptionLineItemContent
      subscriptionLineItemPlaceholdersUsed
      overriddenSetting
      autoApplyCredits
      autoPushInvoice
      generateSiteSpecific
      taxExempted
      allowEmptyInvoice
      autoSendInvoice
      invoiceTemplate {
        templateId
        memo
        title
        footer
        layoutConfiguration
        preferences
      }
      quoteTemplate {
        templateId
        memo
        title
        footer
        layoutConfiguration
        preferences
      }
      salesTax {
        taxId
        name
        rates {
          rateId
          name
          rateValue
        }
      }
      sendTemplate {
        id
        name
        subject
        content
        placeholdersUsed
        to {
          type
          email
          group {
            groupId
            name
            description
          }
          user {
            userId
            email
            name
            firstName
            lastName
          }
          userTypeRole {
            roleId
            name
          }
          placeHolder
        }
        cc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }
        bcc {
          type
          user {
            userId
            email
            firstName
            lastName
            name
          }
          placeHolder
          email
        }
        activated
        templateSubtype
        attachmentList {
          fileName
          originalFileName
          fileSize
        }
      }
      attachPdf
      ignoreConsumedItem
    }
  }
`;

const GET_GLOBAL_INVOICE_TEMPLATE = gql`
  query {
    getGlobalInvoiceTemplate {
      templateId
      title
      memo
      footer
      layoutConfiguration
      preferences
    }
  }
`;

const GET_GLOBAL_QUOTE_TEMPLATE = gql`
  query {
    getGlobalQuoteTemplate {
      templateId
      title
      memo
      footer
      layoutConfiguration
      preferences
    }
  }
`;

const GET_CLIENT_LIST_META_V2 = gql`
  query {
    getClientListViewMetaInfoV2
  }
`;

const GET_CLIENTUSER_ASSOCIATION_LISTVIEW_METAINFO = gql`
  query {
    getClientUserAssociationListViewMetaInfo
  }
`;

const GET_INVOICE_TEMPLATE_PLACEHOLDER_META = gql`
  query {
    getInvoiceTemplatePlaceholdersMeta
  }
`;

const GET_QUOTE_TEMPLATE_PLACEHOLDER_META = gql`
  query {
    getQuoteTemplatePlaceholdersMeta
  }
`;

const GET_CUSTOMER_FEEDBACK_RESPONSE_META = gql`
  query {
    getFeedbackSurveyListViewMeta
  }
`;

const GET_EXPANDED_CLIENT_CONVERSATION_CONTENT = gql`
  query getExpandedClientConversationContent(
    $input: GetExpandedClientConversationContentInput!
  ) {
    getExpandedClientConversationContent(input: $input) {
      conversationId
      time
      subject
      user {
        userId
        firstName
        lastName
        email
        name
      }
      toUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
      }
      ccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      bccUsers {
        user {
          userId
          firstName
          lastName
          name
          email
        }
        mailDeliveryStatus
        mailFailureReason
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
      content
    }
  }
`;

const GET_CLIENT_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getClientList(listInfo: $listInfo) {
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        condition
        sort {
          attribute
          order
        }
      }
      clients {
        logoFileName
        name
        primaryContact {
          name
          firstName
          lastName
          userId
          email
          contactNumber
        }
        secondaryContact {
          name
          firstName
          lastName
          userId
          email
          contactNumber
        }
        customFields
        accountManager {
          name
          firstName
          lastName
          userId
          email
          contactNumber
        }
        stage
        status
        accountId
      }
    }
  }
`;

const GET_REQUESTERS_LIST = gql`
  query($input: GetClientUsersListInput!) {
    getClientUserAssociationsList(input: $input) {
      listInfo {
        page
        pageSize
        hasMore
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
      associations {
        id
        client {
          accountId
          name
        }
        site {
          id
          name
        }
        user {
          userId
          firstName
          lastName
          activated
          activationMailStatus
          activationMailFailureReason
          splashtopWFHEnabled
          remoteDesktopAddOnEnabledStatus
          name
          email
          contactNumber
          role {
            name
            roleId
          }
          reportingManager {
            name
            userId
            firstName
            lastName
          }
          customFields
        }
      }
    }
  }
`;

const GET_USAGE_CONTRACT_PRICE = gql`
  query getUsageContractPrice($input: GetUsageContractPriceInput!) {
    getUsageContractPrice(input: $input)
  }
`;

export {
  GET_CLIENT_LISTVIEW_META,
  GET_CLIENT,
  GET_CLIENT_CONVERSATIONS,
  GET_CLIENT_ATTACHMENTS,
  GET_CLIENT_OFFERINGS,
  GET_WHITELISTED_OFFERINGS,
  GET_CLIENT_CONTRACTS,
  GET_CLIENT_INVOICES,
  GET_INVOICE_STATUSES,
  GET_INVOICE,
  GET_CLIENT_SLA,
  GET_INVOICE_SETTINGS,
  GET_INVOICE_SUMMARY,
  GET_CLIENT_USER_LIST,
  GET_CLIENT_USER_COUNT,
  GET_CLIENT_VIEWS,
  GET_MAILBOX_VIEWS,
  GET_QUOTE_VIEWS,
  GET_CLIENT_INVOICE_SETTINGS,
  GET_CLIENT_INVOICE_SETTING,
  GET_CLIENT_INVOICE_SETTINGS_NEW,
  VALIDATE_EMAIL_ADDRESS,
  GET_SALES_INBOX_VIEWS_COUNT,
  GET_CLIENT_EXPIRED_CONTRACTS,
  GET_CONDITIONS_META_FOR_OFFERED_ITEM,
  GET_CLIENT_USERS_LIST,
  GET_USERS_ASSOCIATIONS_LIST,
  GET_CLIENT_ORIGINAL_MESSAGE,
  GET_CLIENT_USER_ASSOCIATIONS_LIST,
  GET_CLIENT_USER_LISTVIEW_META,
  GET_INVOICE_TEMPLATE,
  GET_GLOBAL_INVOICE_TEMPLATE,
  HARD_DELETE_CONVERSATION,
  SOFT_DELETE_CONVERSATION,
  RESTORE_CONVERSATION,
  GET_CLIENT_INVOICE_SCHEDULE,
  GET_GLOBAL_QUOTE_TEMPLATE,
  GET_QUOTE_LIST,
  GET_QUOTE_TEMPLATE,
  GET_CLIENT_INVOICE_SETTING_NEW,
  GET_CLIENT_LIST_META_V2,
  GET_CLIENTUSER_ASSOCIATION_LISTVIEW_METAINFO,
  GET_SUBSCRIPTION_ITEM_QUANTITY_COUNT,
  GET_CONDITIONS_META_FOR_WORKLOG_ITEM,
  GET_INVOICE_TEMPLATE_PLACEHOLDER_META,
  GET_INVOICE_ADDRESS,
  GET_QUOTE_TEMPLATE_PLACEHOLDER_META,
  GET_CUSTOMER_FEEDBACK_RESPONSE_META,
  GET_EXPANDED_CLIENT_CONVERSATION_CONTENT,
  GET_CLIENT_LIST,
  GET_REQUESTERS_LIST,
  GET_CLIENT_WITH_CUSTOM_FIELDS,
  GET_USAGE_CONTRACT_PRICE
};
